import React from 'react'
import ChartFlexSection from '@components/chart/ChartFlexSection'
import { IResponseOptProjectBudgetStats } from '@interfaces/api/IDashboard'
import TextChartTitle from '@components/text/TextChartTitle'
import CardDashboardStatGroup from '@components/card/CardDashboardStatGroup'
import { Money, Num, ThY } from '@utils/utils'
import Stat from '@components/chart/Stat'
import Chart from 'react-google-charts'
import { ColumnChartOptions } from '@components/chart/setting'
import _ from 'lodash'

const ProjectBudgetStats = ({ title, data }: { title: string; data: IResponseOptProjectBudgetStats }) => {
  const options = ColumnChartOptions('มูลค่าโครงการ', 'ปีงบประมาณ')
  const chartData = [
    ['ปีงบประมาณ', 'มูลค่าโครงการ', { type: 'string', role: 'annotation' }, { role: 'tooltip', type: 'string', p: { html: true } }],
    ...data.map((item) => [
      String(ThY(item.budget_year)), // ← Annotation label (appears on bar)
      parseFloat(item.total_budget),
      Money(item.total_budget),
      `<div style="padding:8px; width: 280px">
        <strong>ปีงบประมาณ ${ThY(item.budget_year)}</strong><br/>
        จำนวนโครงการ : ${item.total_projects} โครงการ<br/>
        มูลค่าโครงการ : ${Money(item.total_budget)} บาท
      </div>`,
    ]),
  ]

  return (
    <ChartFlexSection>
      <TextChartTitle>{title}</TextChartTitle>
      {data.length > 1 && (
        <CardDashboardStatGroup>
          <Stat w={150} label={'จำนวนโครงการ'} value={Num(_.sum(data.map((r) => r.total_projects)))} unit="โครงการ" />
          <Stat w={300} label={'มูลค่าโครงการ'} value={Money(_.sum(data.map((r) => parseFloat(r.total_budget))))} unit="บาท" />
        </CardDashboardStatGroup>
      )}
      {data.map((result, index) => {
        return (
          <CardDashboardStatGroup key={result.budget_year}>
            <Stat w={150} label={index > 0 ? '' : 'ปีงบประมาณ'} value={ThY(result.budget_year)} />
            <Stat
              w={150}
              label={index > 0 ? '' : 'จำนวนโครงการ'}
              value={Num(result.total_projects)}
              unit="โครงการ"
              diff={result.total_projects_diff}
            />
            <Stat w={300} label={index > 0 ? '' : 'มูลค่าโครงการ'} value={Money(result.total_budget)} unit="บาท" diff={result.total_budget_diff} />
          </CardDashboardStatGroup>
        )
      })}
      <Chart width={'100%'} height={'500px'} chartType="ColumnChart" loader={<div>Loading Chart</div>} data={chartData} options={options} />
    </ChartFlexSection>
  )
}

export default ProjectBudgetStats
